import {
  transformSavings,
  transformSavingsDetails,
} from '@/common/integrations/menhir/employee/savings/savings.dto';
import {
  TMenhirSavingsFullEnvelope,
  TMenhirSavingsSimpleEnvelope,
  TSavingsFull,
} from '@/common/integrations/menhir/employee/savings/savings.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { TMoney } from '@coverflex-tech/hypernova-utils';

export const getSavingsTotal = (): Promise<TMoney> =>
  menhirClient
    .get<null, TMenhirSavingsSimpleEnvelope>(
      MENHIR_ENDPOINTS.EMPLOYEE.SAVINGS,
      {
        params: { format: 'simple' },
      }
    )
    .then((envelope) => {
      return transformSavings(envelope);
    });

export const getSavingsDetails = ({
  month,
  year,
}: { month?: number; year?: number } = {}): Promise<TSavingsFull> =>
  menhirClient
    .get<null, TMenhirSavingsFullEnvelope>(MENHIR_ENDPOINTS.EMPLOYEE.SAVINGS, {
      params: {
        format: 'full',
        month,
        year,
      },
    })
    .then((envelope) => transformSavingsDetails(envelope));
